export const SUPPORTS_MAP = typeof Map !== "undefined";
